import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { PedidoInterface } from "app/module/pedido-interface";

@Injectable({
	providedIn: 'root'
})
export class PedidoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public get(): Observable<PedidoInterface[]> {
		return this.http.get<PedidoInterface[]>(`${this.url}pedido`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getOne(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}pedido/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public post(data): Observable<any> {
		return this.http.post<any>(`${this.url}pedido/create`, {
			data
		}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public cancelarPedido(id_pedido): Observable<any> {
		return this.http.post<any>(`${this.url}pedido/cancelar/${id_pedido}`, null, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public aprovarPagamento(data): Observable<any> {
		return this.http.post<any>(`${this.url}pedido/aprovar`, {
			data
		}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public confirmarEnvio(data): Observable<any> {
		return this.http.post<any>(`${this.url}pedido/enviado`, {
			data
		}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public confirmarConfiguracao(data): Observable<any> {
		return this.http.post<any>(`${this.url}pedido/configuracao`, {
			data
		}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public put(data: any, id: number): Observable<any> {
		return this.http
			.put<any>(`${this.url}pedido/${id}`, {
				id_cliente: data.id_cliente,
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getPedidoRastreador(): Observable<any> {
		return this.http.get<any>(`${this.url}pedido/rastreador`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getOnePedidoRastreador(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}pedido/rastreador/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public createPedidoRastreador(data): Observable<any> {
		console.log(data);
		
		return this.http.post<any>(`${this.url}pedido/rastreador`, {
			cliente: data.cliente,
			vendedor: data.vendedor,
			produtos: data.produtos,
			gerarNF: data.gerarNF,
			instalarPlataforma: data.instalarPlataforma,
			chipRastreei: data.chipRastreei
		}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public confirmarSeparacao(id_pedido: number, imeis: string[]): Observable<any> {
		return this.http.post<any>(`${this.url}pedido/rastreador/separacao`, {
			id_pedido: id_pedido,
			imeis: imeis
		}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getConfiguracoes(id_pedido: number): Observable<any> {
		return this.http.get<any>(`${this.url}pedido/configuracoes/${id_pedido}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	// public delete(data: number, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}sistema/${id}/update`, {
	// 			id_sistema: id,
	// 			isDeleted: data,
	// 		})
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }

	public getPedidoEmpresa(pIdEmpresa): Observable<PedidoInterface[]> {
		return this.http.get<PedidoInterface[]>(`${this.url}pedido/empresa/${pIdEmpresa}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
